// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vms-icon[data-v-a3633e94]{font-size:25px}", ""]);
// Exports
module.exports = exports;
